import axios from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'

axios.defaults.withCredentials = true;

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: { 'Cache-Control': 'no-cache' },
  adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
})

const API = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  AUTOCONNECT: '/connect',
  AUTH: '/auth',
  POSTME: '/me',
  PUTME: '/me',
  GETCONTACTDETAILS: '/contact-details',
  POSTCONTACTMESSAGES: '/contact-messages',
  GETBANNERHOME: '/banner-home',
  POSTLOGINBYIP: '/login-ip',
  ACTIVITY: '/audit',
  FORGETPASSWORD: '/forgot-password',
  RESETTOKENPASSWORD: '/validate-token',
  NEWUSERPASSWORD: '/update-password',
  EMAILAUTOCONNECT: '/login-with-email',
  EXPORTFORMAT: '/export/format',
  REFRESHTOKEN: '/refesh'
}

function url(path, ...segments) {
  let i = 0
  const uri = path.replace(/:\w+/g, () => {
    let s = segments[i]
    i += 1
    return s
  })

  return uri
}

export default {
  /* eslint-disable */
  install(app, options) {
    const $api = {
      postLogin(data) {
        return http.post(url(API.LOGIN), data, { cache: false })
      },
      postConnnect(data) {
        return http.post(url(API.AUTOCONNECT), data, { cache: false })
      },
      postLogout(data) {
        return http.post(url(API.LOGOUT), data, { cache: false })
      },
      postAuth(data) {
        return http.post(url(API.AUTH), data, { cache: false })
      },
      postUser(data) {
        return http.post(url(API.REGISTER), data, { cache: false })
      },
      postMe(token) {
        return http.post(url(API.POSTME), { token: token }, { cache: false })
      },
      putMe(data) {
        return http.put(url(API.PUTME), data)
      },
      getContactDetails() {
        return http.get(url(API.GETCONTACTDETAILS))
      },
      postContactMessages(data) {
        return http.post(url(API.POSTCONTACTMESSAGES), data, { cache: false })
      },
      getBannerHome() {
        return http.get(url(API.GETBANNERHOME), { cache: false })
      },
      postLoginByIP(ip) {
        return http.post(url(API.POSTLOGINBYIP), { ip: ip }, { cache: false })
      },
      postActivity(data) {
        return http.post(url(API.ACTIVITY), data, { cache: false })
      },
      postForgetPassword(data) {
        return http.post(url(API.FORGETPASSWORD), data, { cache: false })
      },
      postResetTokenPassword(data) {
        return http.post(url(API.RESETTOKENPASSWORD), data, { cache: false })
      },
      postNewUserPassword(data) {
        return http.post(url(API.NEWUSERPASSWORD), data, { cache: false })
      },
      postEmailAutoconnect(data) {
        return http.post(url(API.EMAILAUTOCONNECT), data, { cache: false })
      },
      postExportFormat(data) {
        return http.post(url(API.EXPORTFORMAT), data, { cache: false, responseType: 'blob' })
      },
      postRefresh(data) {
        return http.post(url(API.REFRESHTOKEN), data, { cache: false })
      }
    }

    app.config.globalProperties.$api = $api
  }
}
